import { useEntitlements } from "@/shared/entitlements/entitlements.context";
import type { Entitlements } from "@/shared/entitlements/schemas/entitlements.schema";

/// The account's AI credit pool (`used` / `grant` / `remaining`). Null
/// `grant`/`remaining` means unlimited. Backs the sidebar + account settings
/// credit meters and the writing-assist gate (W2 / W3).
export function useCredits(): Entitlements["credits"] {
  return useEntitlements().credits;
}
